module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.4312f1fb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.ttf
// module id = 542
// module chunks = 0